<template>
  <div>
    <Layout />
    <v-container grid-list-md>
      <notifications position="bottom center" />
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn depressed color="primary" @click="print()">
            <i class="fas fa-print"></i> </v-btn
        ></v-flex>
        <v-flex xs12>
          <h3>PEDIDO: #{{ id }}</h3>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: 0,
      valid: false,
      client: null,
      session: false,
      dark: false,
      name: null,
      phone: null,
      address: null,
      newAddress: false,
      items: [],
      obs: null,
      product: null,
      qty: null,
      total: 0,
      total_payment: 0,
      items_payment: [],
      type_payment: null,
      types_payment: [],
      value_payment: 0,
      type_payment_limit: 1,
      plots: 1,
    };
  },
  filters: {},
  watch: {},
  created() {
    this.id = this.$route.params.id;

    this.getOrder(this.id);
  },
  methods: {
    getOrder(id) {
      this.$http
        .get(`/orders/${id}`)
        .then((response) => response.data)
        .then((json) => {
          setTimeout(() => {
            console.log("DATA", json);
            this.client = json.client;
            this.name = json.client.name;
            this.phone = json.client.phone;
            this.address = json.order.address;
            this.obs = json.order.obs;
            this.total = parseFloat(json.order.total).toFixed(2);

            console.log("PHONE", this.phone);

            const arr = [];
            json.items_order.forEach((o) => {
              arr.push({
                id: o.product_id,
                price: parseFloat(o.price).toFixed(2),
                qty: o.qty,
                total: parseFloat(o.total).toFixed(2),
                cost: parseFloat(o.cost).toFixed(2),
                total_cost: parseFloat(o.qty * o.cost).toFixed(2),
              });
            });

            console.log("types_payment", this.types_payment);

            this.value_payment = this.total;
            this.total_payment = this.total;
            this.items = arr;

            const arr_b = [];
            json.item_payment.forEach((o) => {
              arr_b.push({
                id: o.id,
                type: o.type,
                type_code: o.type_payment_id,
                value: o.total,
                plots: o.plots,
              });
            });

            this.items_payment = arr_b;
          }, 1000);
        })
        .catch(() => (this.loading = false));
    },
    print(){
        window.print();
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
<style>
@media print {
    .no-print{
        display: none;
    }
}
</style>